import { render } from "./Presents.vue?vue&type=template&id=568b76fd&scoped=true"
import script from "./Presents.vue?vue&type=script&lang=js"
export * from "./Presents.vue?vue&type=script&lang=js"

import "./Presents.vue?vue&type=style&index=0&id=568b76fd&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.16_vue@3.5.16_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568b76fd"]])

export default __exports__